import React from 'react'
import CSSModules from 'react-css-modules'
import styles from './App.scss'

import { Route, Switch } from 'react-router-dom'
import { ConnectedRouter as Router } from 'react-router-redux'

import AppBody from 'components/AppBody'

import { MainNav, SubNav } from './components/Navigation'

import {
	Home,
	Apps,
	Explore,
	Loading,
	Page404,
	PageUnauthorized
} from './views'

import { connect } from 'react-redux'

import history from './history'

class App extends React.Component {
	render() {
		return (
			<Router history={history}>
				{this.props.isAuthenticated ? (
					<div styleName="app">
						<Route component={MainNav} />
						<Route path="/apps/:appId" component={SubNav} />

						<AppBody>
							<Switch>
								<Route exact path="/" component={Home} />
								<Route path="/apps" component={Apps} />
								<Route path="/explore" component={Explore} />
								<Route
									path="/unauthorized"
									component={PageUnauthorized}
								/>
								<Route component={Page404} />
							</Switch>
						</AppBody>
					</div>
				) : (
					<div styleName="app">
						<Loading />
					</div>
				)}
			</Router>
		)
	}
}

const mapStateToProps = (state, ownProps) => {
	return {
		isAuthenticated: state.user.isAuthenticated
	}
}

// const mapDispatchToProps = (dispatch, ownProps) => {}

export default connect(mapStateToProps)(CSSModules(App, styles))



// WEBPACK FOOTER //
// ./src/App.js